import React, {useState} from "react";
import Carousel from "react-multi-carousel";
import styled from "styled-components";
import Image from "./Components/Image.Gallery";
import {CustomLeftArrow, CustomRightArrow} from "../Components/CustomArrows";

const GalleryCarousel = styled(Carousel)`

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakSmall}) {
    position: unset !important; // Override carousel default positioning
  }

`;

const responsive = {
  superLargeDesktop: {
    breakpoint: {max: 5000, min: 0},
    items: 3,
  },
  desktop: {
    breakpoint: {max: 2560, min: 0},
    items: 1,
  },
  laptop: {
    breakpoint: {max: 1024, min: 0},
    items: 1,
  },
  tablet: {
    breakpoint: {max: 768, min: 0},
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

function Gallery({ data }) {
  const [isImageZoomed, setIsImageZoomed] = useState(false);
  const isImageZoomedHandler = (value) => setIsImageZoomed(value);

  return (
    <GalleryCarousel
      className="GalleryCarousel"
      responsive={responsive}
      minimumTouchDrag={0}
      // autoPlay prop doesn't seem to work so that's why the autoPlaySpeed is set to 10h
      autoPlay={false}
      autoPlaySpeed={36000000}
      arrows
      customLeftArrow={<CustomLeftArrow specialsType="gallery"/>}
      customRightArrow={<CustomRightArrow specialsType="gallery"/>}
      swipeable={!isImageZoomed}
      draggable={!isImageZoomed}
    >
      {data.map((el, key) => {
        return <Image data={el} isImageZoomed={isImageZoomedHandler} key={`gallery-images-${key}`}/>;
      })}
    </GalleryCarousel>
  );
}

export default Gallery;
